import { UserCircleIcon } from '@heroicons/react/outline';

import BaseIcon, { IconProps } from '@/components/icons/base-icon';

export default function ProfileIcon(props: IconProps) {
  return <BaseIcon Icon={UserCircleIcon} {...props} />;
}
